<template>
  <Modal nome="editarPerfil">
    <Campo tipo="text" placeholder="Ex: João Silva" completar="false" label="Seu nome" v-model="state.nome" />
    <Campo tipo="tel" placeholder="(00) 00000-0000" completar="false" label="Seu whatsapp" mascara="(##) #####-####" v-model="state.whatsapp" />
    <Imagem label="Foto de perfil" tamanho="Recomendado 500x500" v-model:url="state.fotoPerfil" :imagemPreenchida="state.fotoPerfil" />
    <BotaoPrincipal nome="Salvar perfil" :disabled="state.loading" @click="salvar" />
  </Modal>
</template>

<script setup>
import { reactive, onMounted, inject } from 'vue'
import { useStorePerfil, useStoreModal } from '@stores'
import Modal from '@components/global/modal/Modal.vue'
import BotaoPrincipal from '@/components/global/elementos/BotaoPrincipal.vue'
import Campo from '@/components/global/elementos/Campo.vue'
import Imagem from '@/components/global/elementos/Imagem.vue'

const emitter = inject('emitter')
const storePerfil = useStorePerfil()
const storeModal = useStoreModal()

const state = reactive({
  nome: '',
  whatsapp: '',
  fotoPerfil: '',
  loading: false
})

async function salvar() {
  state.loading = true

  const payload = {
    nome: state.nome,
    imagemPerfil: state.fotoPerfil,
    contato: {
      whatsapp: state.whatsapp
    }
  }

  if (state.nome || state.whatsapp || state.fotoPerfil) {
    await storePerfil.alterarDados(payload)
  }

  await storePerfil.receberPerfilUsuario()
  state.loading = false
  emitter.emit('atualizarPerfil')
  storeModal.fecharModal('editarPerfil')
}

async function preencherInputs() {
  await storePerfil.receberPerfilUsuario()
  state.nome = storePerfil.usuario?.nome
  state.whatsapp = storePerfil.usuario?.contato?.whatsapp
  state.fotoPerfil = storePerfil.usuario?.imagemPerfil
}

function limparCampos() {
  state.fotoPerfil = ''
  state.nome = ''
  state.whatsapp = ''
}

onMounted(() => {
  preencherInputs()
  emitter.on('carregarCampos', preencherInputs)
  emitter.on('limparCampos', limparCampos)
})
</script>

<style scoped>
.campo {
  margin: 0 0 15px 0;
}
.imagem {
  margin: 0 0 15px 0;
}

/* Responsivo */
@media screen and (max-width: 1024px) {
  .titulo {
    padding: 20px;
  }

  .botao {
    padding: 20px;
  }

  .campos {
    padding: 20px 20px 0 20px;
  }
}
</style>
